import React, { useState } from 'react';
import 'flatpickr/dist/flatpickr.min.css';
import { Link, useNavigate } from 'react-router-dom';
import WebHeader from '../../WebHeader/WebHeader';
import Sidebar from '../../Sidebar/Sidebar';
import WebFooter from '../../WebFooter/WebFooter';
import { API_URL } from '../../../Config';

const AddCompanyDatabase = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        companyName: '',
        username: '',
        membershipStatus: '',
        panNumber: '',
        partnerName: '',
        emailID: '',
        mobile: '',
        faxNumber: '',
        companyRoomDiscount: 0,
        totalRewardPoints: '',
        address: '',
        postcode: '',
        city: '',
        country: '',
        bankName: '',
        branchAddress: '',
        accountNumber: '',
        typeOfAccount: '',
        password: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_URL}/addCompany`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();
            if (response.ok) {
                alert('Company added successfully');
                navigate('/CompanyDatabase');
            } else {
                alert(`Failed to add company: ${result.error}`);
            }
        } catch (error) {
            console.error('Error adding company:', error);
            alert('Failed to add company');
        }
    };

    return (
        <div className='bg-[#F8F6F6] text-[14px] md:text-xl lg:text-[16px] 2xl:text-2xl leading-6 md:leading-8 lg:leading-7 2xl:leading-10'>
            <WebHeader />

            <div className='hidden lg:block'>
                <Sidebar />
            </div>
            <br />

            <div className='mt-[70px] mx-[3%] lg:ml-[23%]'>

                <Link
                    to="/CompanyDatabase"
                    className='text-[#008080] hover:underline'
                >Go Back</Link>

                <div className='bg-white rounded-lg p-[3%] lg:p-[2%] mb-[2vw]'>
                    <p className='font-semibold'>COMPANY PROFILE DATABASE</p>

                    <form onSubmit={handleSubmit}>
                        <p className='mt-[2%] text-lg md:text-2xl lg:text-xl 2xl:text-3xl'>Company Profile</p>
                        <hr className='my-[2%]' />

                        <div className='grid grid-cols-1 lg:grid-cols-2'>
                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Company Name*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='companyName' value={formData.companyName} onChange={handleInputChange} />
                            </div>

                            <div class="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label class="block text-xs font-medium text-gray-900">Username*</label>
                                <input type="text" class="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='username' value={formData.username} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Membership Status*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='membershipStatus' value={formData.membershipStatus} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Company/ Firm PAN No.*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='panNumber' value={formData.panNumber} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Name of Proprietor/ Partner/ Directors*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-300 focus:ring-0 outline-none bg-transparent" placeholder='Add more names, each followed by a comma' name='partnerName' value={formData.partnerName} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Email ID*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='emailID' value={formData.emailID} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Telephone Number*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='mobile' value={formData.mobile} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Fax Number</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='faxNumber' value={formData.faxNumber} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Password</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='password' value={formData.password} onChange={handleInputChange} />
                            </div>
                        </div>

                        <p className='mt-[3%] font-semibold'>ROOM DISCOUNTS & MORE</p>
                        <hr className='my-[2%]' />

                        <div className='grid grid-cols-1 lg:grid-cols-4'>
                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Company Room Discount %*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='companyRoomDiscount' value={formData.companyRoomDiscount} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Total Reward Points*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='totalRewardPoints' value={formData.totalRewardPoints} onChange={handleInputChange} />
                            </div>
                        </div>

                        <p className='mt-[3%] font-semibold'>HEAD OFFICE ADDRESS</p>
                        <hr className='my-[2%]' />

                        <div className='grid grid-cols-1 lg:grid-cols-3'>
                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Address*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='address' value={formData.address} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Postcode*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='postcode' value={formData.postcode} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">City*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='city' value={formData.city} onChange={handleInputChange} />
                            </div>

                            <div class="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label class="block text-xs font-medium text-gray-900">Country*</label>
                                <input type="text" class="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='country' value={formData.country} onChange={handleInputChange} />
                            </div>

                        </div>

                        <p className='mt-[3%] font-semibold'>ABOUT BANK</p>
                        <hr className='my-[2%]' />

                        <div className='grid grid-cols-1 lg:grid-cols-3'>
                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Bank Name*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='bankName' value={formData.bankName} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Branch Address*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='branchAddress' value={formData.branchAddress} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Account No.*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='accountNumber' value={formData.accountNumber} onChange={handleInputChange} />
                            </div>

                            <div className="border bg-white rounded-lg my-[2%] lg:mx-[3%] px-[3%] py-[1%] h-[3.5em] focus-within:border-teal-600">
                                <label className="block text-xs font-medium text-gray-900">Type of Account*</label>
                                <input type="text" className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 outline-none bg-transparent" name='typeOfAccount' value={formData.typeOfAccount} onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="flex justify-end mt-[2%]">
                            <button type="submit" className="flex items-center bg-[#008080] text-white shadow-custom rounded-lg px-[3%] hover:scale-110">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <br />

            <WebFooter />
        </div>
    );
};

export default AddCompanyDatabase;
